/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/stop" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEmailIpWarmingAppGroupIdStopCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdStopProps,
  PostEmailIpWarmingStopResult,
  PostEmailIpWarmingStopResultErrors,
} from "./types";

export const postEmailIpWarmingStop = reactQueryMutationAdapter(
  postEmailIpWarmingAppGroupIdStopCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEmailIpWarmingStopResultErrors>()(
    (props: PostEmailIpWarmingAppGroupIdStopProps): Promise<PostEmailIpWarmingStopResult> => {
      return fetch(`/email/ip_warming/${props.appGroupId}/stop`, "POST", props, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
